export enum ConnectorStages {
  PUBLISH = 'publish',
  QC = 'qc',
  DEV = 'dev',
}
